module.exports = __webpack_public_path__ + "static/media/dailyIcon2.20df2382.svg";